"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SvgCloudOff = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
    React.createElement("path", { d: "M28.934 21.49a6 6 0 0 0-5.04-8.132 8 8 0 0 0-9.628-6.503m-4.55 2.86a7.96 7.96 0 0 0-1.61 3.644 6 6 0 0 0 .56 11.974h14.667a6 6 0 0 0 1.749-.258M4 4l24 24" }))); };
exports.default = SvgCloudOff;
//# sourceMappingURL=CloudOff.js.map